import { FormModal } from '../../Form'

import {
  EMAIL_ADD_NOTE_FIELD_MAX_LENGTH,
  EMAIL_ADD_NOTE_FIELD_NAME_NOTE,
  EMAIL_ADD_NOTE_FIELD_TEXTAREA_MIN_ROWS,
} from './EmailAddNoteActionModal.constants'
import { getEmailAddNoteValidationSchema } from './EmailAddNoteActionModal.utils'
import { EmailAddNoteActionModalFields } from './EmailAddNoteActionModalFields'

function EmailAddNoteActionModal({ id, initialValues, onClose, onSubmit }) {
  const validationSchema = getEmailAddNoteValidationSchema(initialValues)

  function handleSubmit({ values }) {
    onSubmit(id, values)
  }

  return (
    <FormModal
      Fields={EmailAddNoteActionModalFields}
      formBodyProps={{
        withNotifications: true,
      }}
      formFieldsProps={{
        noteProps: {
          maxLength: EMAIL_ADD_NOTE_FIELD_MAX_LENGTH,
          minRow: EMAIL_ADD_NOTE_FIELD_TEXTAREA_MIN_ROWS,
          name: EMAIL_ADD_NOTE_FIELD_NAME_NOTE,
        },
      }}
      formTitle='Modal.EmailAddNoteTitleKey'
      initialValues={initialValues}
      validationSchema={validationSchema}
      onClose={onClose}
      onSubmit={handleSubmit}
    />
  )
}

export default EmailAddNoteActionModal
